import React from 'react'
import NumberInputField from '../../formFields/numberInputField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <NumberInputField {...fieldProps} />
))
